import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const postInviteSupplier = createApi(`PostInviteSupplierListSlice`,"POST");

const PostInviteSupplierListSlice = createSlice({
  name: 'PostInviteSupplierListSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postInviteSupplier.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postInviteSupplier.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postInviteSupplier.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PostInviteSupplierListSlice.reducer;